module.exports = __webpack_public_path__ + "src/assets/img/sultan-selector-plane-2.ac75ac39.png";